import { render, staticRenderFns } from "./classSurvey.vue?vue&type=template&id=38beca51&scoped=true&"
import script from "./classSurvey.vue?vue&type=script&lang=js&"
export * from "./classSurvey.vue?vue&type=script&lang=js&"
import style0 from "./classSurvey.vue?vue&type=style&index=0&id=38beca51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38beca51",
  null
  
)

export default component.exports